import { render } from "./TermsServicePage.vue?vue&type=template&id=3155e513"
import script from "./TermsServicePage.vue?vue&type=script&lang=js"
export * from "./TermsServicePage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pavithram.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__